import React from 'react';
import { Sidebar } from './sidebar';
import { Chat } from './chat';

const App = () => {

  const [chatSelected, setChatSelected] = React.useState(null);

  return (
    <div className="flex h-[calc(100vh-6rem)]">
      <Sidebar
        selectedChat={setChatSelected}
      />
      <Chat
        chatSelected={chatSelected}
      />
    </div>
  );
};

export default App;
